// extracted by mini-css-extract-plugin
export default {"promise-holder":"ProjectPromises_promise-holder__ZQLqa","heading-holder":"ProjectPromises_heading-holder__1t24v"};